import Rosettas from '../lib/rosettas'

export const TrosettaAPI = {
  crear: Rosettas.crear,
  elegirIdiomaVisible: Rosettas.elegirIdiomaVisible,
  idiomaVisible: Rosettas.idiomaVisible,
  idiomasDisponibles: Rosettas.idiomasDisponibles,
  identificarLenguajePreferidoPorNavegador: Rosettas.identificarLenguajePreferidoPorNavegador,
  init: Rosettas.init
}
